(function () {
  'use strict';

  function filenameFrom(response, fallback) {
    var disposition = response.headers.get('content-disposition') || '';
    var match = disposition.match(/filename="([^"]+)"/i);
    return match ? match[1] : fallback;
  }

  async function download(endpoint, payload, fallbackFilename) {
    var response = await fetch('/apps/plant-x-me' + endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/pdf' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      var message = 'La création du PDF est momentanément indisponible.';
      try {
        var error = await response.json();
        if (error && error.error) message = error.error;
      } catch (_) {}
      throw new Error(message);
    }
    if ((response.headers.get('content-type') || '').indexOf('application/pdf') === -1) {
      throw new Error('Le fichier reçu est invalide.');
    }
    var blob = await response.blob();
    var objectUrl = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = objectUrl;
    link.download = filenameFrom(response, fallbackFilename || 'plant-x-me.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 30000);
  }

  window.PxmPdfDownload = { download: download };
})();
